import {
  FaTachometerAlt,
  FaUsers,
  FaChartLine,
  FaChartBar,
} from "react-icons/fa";

const modules = [
  {
    id: 1,
    name: "Team Management",
    path: "/team-management",
    icon: FaTachometerAlt,
    subModules: [
      {
        id: 6,
        name: "Team",
        path: "/team",
      },
      // {
      //   id: 7,
      //   name: "Team Detail",
      //   path: "/team-detail",
      // },
    ],
  },
  {
    id: 2,
    name: "Hr Action Management",
    path: "/hr-action-management",
    icon: FaTachometerAlt,
  },
];

export type moduleType = typeof modules;

export default modules;
